import { Loader } from '@rikstv/shared-components';

export const CoverPageLoader = () => (
  <section style={{ display: 'grid', height: '50vh', placeContent: 'center' }}>
    <Loader size="large" />
  </section>
);
